<template>
  <component
    :is="surveyComponent"
    v-if="survey"
    :pathway="pathway"
    :step="step"
    :consumer-key="consumerKey"
    :survey="survey"
  />
</template>

<script lang="ts" setup>
import {computed, onMounted, ref} from "vue";
import type {Component} from "vue";
import {Pathway, PathwayStep} from "@/program/interfaces/Program";
import {Survey} from "@/core/interfaces/survey/Survey";
import {surveyApi} from "@/container";
import PathwayInlineSurveyForm from "@/pathway/components/PathwayInlineSurveyForm.vue";
import PetInlineSurvey from "@/pathway/components/PetInlineSurvey.vue";

/**
 * The surveys needing more than the plain form, by slug: their answers also
 * feed a profile stored outside of the survey.
 */
const SURVEY_COMPONENTS: Record<string, Component> = {
    'viatris-pet': PetInlineSurvey
};

const props = defineProps<{
    pathway: Pathway;
    step: PathwayStep;
    consumerKey: string;
}>();

const survey = ref<Survey>();

/**
 * On mounted, read the survey attached to the step.
 */
onMounted(async () => {
    survey.value = await surveyApi().readBuiltSurvey(props.step.steppable.id);
});

/**
 * The component handling the survey.
 */
const surveyComponent = computed<Component>(() => {
    return (survey.value && SURVEY_COMPONENTS[survey.value.slug]) || PathwayInlineSurveyForm;
});

</script>
